<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
  Download rapport for {{ data.organizationName }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="downloadReportFormGroup" (submit)="downloadReport()">
  <mat-dialog-content>
    @if (downloadReportFormGroup.controls.selectedReportType.value === reportTypeEnum.LOCATION) {
      <div>
        <ok-feedback-info>Vær opmærksom på at der kun medtages færdige ladninger i lokationsrapporten. </ok-feedback-info>
      </div>
    }

    <div class="form-row">
      <mat-label>Type</mat-label>
      <mat-radio-group formControlName="selectedReportType" name="reportType">
        <mat-radio-button [value]="reportTypeEnum.INVOICE" [admRequiresFeatureRole]="roles['invoice-report.download']">
          Faktureringsrapport for flådebiler m. kontonr. og håndteringsgebyr
        </mat-radio-button>
        <mat-radio-button [value]="reportTypeEnum.INVOICE_FOR_LOCATIONS" [admRequiresFeatureRole]="roles['invoice-report.download']"
          >Faktureringsrapport for lokation m. aftalenr.</mat-radio-button
        >
        <mat-radio-button [value]="reportTypeEnum.CONSUMPTION" [admRequiresFeatureRole]="roles['customer-report.download']">
          Forbrugsrapport (også tilgængelig for kunder)</mat-radio-button
        >
        <mat-radio-button [value]="reportTypeEnum.LOCATION" [admRequiresFeatureRole]="roles['customer-report.download']"
          >Lokationsrapport (også tilgængelig for kunder)</mat-radio-button
        >
        <mat-radio-button [value]="reportTypeEnum.SUMMARIZED_INVOICE" [admRequiresFeatureRole]="roles['invoice-report.download']"
          >Summeret faktureringsrapport</mat-radio-button
        >
      </mat-radio-group>
    </div>
    @if (selectedReportType.value === reportTypeEnum.INVOICE || selectedReportType.value === reportTypeEnum.INVOICE_FOR_LOCATIONS) {
      <div class="form-row">
        @if (departmentFiltersLoaded && departmentGroups.length === 0) {
          <p class="bold">Afdelingsgruppe</p>
          <span class="icon-with-text orange filter-text">
            <mat-icon>info</mat-icon>
            <span>Organisationen har ingen afdelingsgrupper</span>
          </span>
        }
        @if (departmentGroups.length > 0) {
          <mat-form-field class="department-groups">
            <mat-label>Afdelingsgruppe</mat-label>
            <mat-select formControlName="selectedDepartmentGroup" [compareWith]="compareDepartmentGroups">
              @for (departmentGroup of departmentGroups; track departmentGroup.id) {
                <mat-option [value]="departmentGroup">
                  {{ departmentGroup.name }}
                </mat-option>
              }
            </mat-select>
            @if (hasSelectedDepartmentGroup && !isSpecificDepartmentDialog) {
              <button
                matSuffix
                class="clear-input-field-button"
                type="button"
                (click)="resetDepartmentGroup($event)"
                aria-label="Ryd indhold i feltet">
                <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
              </button>
            }
          </mat-form-field>
        }
        @if (
          departmentGroups.length > 0 &&
          hasSelectedDepartmentGroup &&
          (selectedReportType.value === reportTypeEnum.INVOICE || selectedReportType.value === reportTypeEnum.INVOICE_FOR_LOCATIONS)
        ) {
          <span class="icon-with-text orange filter-text">
            <mat-icon>info</mat-icon>
            <span>Filtrerer afdelinger, der er tilknyttet afdelingsgruppen på nuværende tidspunkt</span>
          </span>
        }
      </div>
      <div class="form-row">
        @if (departmentFiltersLoaded && departments.length === 0) {
          <p class="bold">Afdeling</p>
          <span class="icon-with-text orange filter-text">
            <mat-icon>info</mat-icon>
            <span>Organisationen har ingen afdelinger</span>
          </span>
        }
        @if (departments.length > 0) {
          <mat-form-field class="departments">
            <mat-label>Afdeling</mat-label>
            <mat-select formControlName="selectedDepartment" placeholder="Afdeling">
              @for (department of departments; track department.id) {
                <mat-option [value]="department">
                  {{ department.name }}
                </mat-option>
              }
            </mat-select>
            @if (hasSelectedDepartment && !isSpecificDepartmentDialog) {
              <button
                matSuffix
                class="clear-input-field-button"
                type="button"
                (click)="resetDepartment($event)"
                aria-label="Ryd indhold i feltet">
                <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
              </button>
            }
          </mat-form-field>
        }
        @if (departmentFilterMessage) {
          <span class="icon-with-text orange filter-text">
            <mat-icon>info</mat-icon>
            <span>{{ departmentFilterMessage }}</span>
          </span>
        }
      </div>
    }
    @if (
      selectedReportType.value === reportTypeEnum.LOCATION ||
      selectedReportType.value === reportTypeEnum.CONSUMPTION ||
      selectedReportType.value === reportTypeEnum.SUMMARIZED_INVOICE
    ) {
      <div class="form-row custom-selector-field">
        <span class="custom-selector-field__row-label">Lokationer</span>
        <button type="button" (click)="openLocationSelector()" class="custom-selector-field__toggle">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
          <span class="custom-selector-field__input-label">Vælg lokationer</span>
          @if (locationBadgeCount > 0) {
            <span class="custom-selector-field__chosen">
              <div matBadge="{{ locationBadgeCount }}" matBadgeOverlap="false">Valgt</div>
            </span>
          }
          <mat-icon class="custom-selector-field__arrow" matSuffix>keyboard_arrow_down</mat-icon>
        </button>
        @if (locationBadgeCount > 0) {
          <button class="custom-selector-field__clear-input" type="button" (click)="resetLocations()" aria-label="Ryd indhold i feltet">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
          </button>
        }
      </div>
    }
    @if (selectedReportType.value === reportTypeEnum.CONSUMPTION) {
      <div class="form-row custom-selector-field">
        <span class="custom-selector-field__row-label">Brikker</span>
        <button type="button" (click)="openIdTagSelector()" class="custom-selector-field__toggle">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
          <span class="custom-selector-field__input-label">Vælg brikker</span>
          @if (idTagBadgeCount > 0) {
            <span class="custom-selector-field__chosen">
              <div matBadge="{{ idTagBadgeCount }}" matBadgeOverlap="false">Valgt</div>
            </span>
          }
          <mat-icon class="custom-selector-field__arrow" matSuffix>keyboard_arrow_down</mat-icon>
        </button>
        @if (idTagBadgeCount > 0) {
          <button class="custom-selector-field__clear-input" type="button" (click)="resetIdTags()" aria-label="Ryd indhold i feltet">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
          </button>
        }
      </div>
    }
    <div class="form-row mat-date-range-input">
      <mat-form-field>
        <mat-label>Periode</mat-label>
        <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
          <input formControlName="startDate" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
          <input formControlName="endDate" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button mat-dialog-close type="button" mat-button>Annuller</button>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="downloadReportFormGroup.invalid || loading"
        [class.spinner]="loading">
        Download rapport
      </button>
    </div>
  </mat-dialog-actions>
</form>
